import { toPublicAgencyCard } from './agencyUrl';

// Searches made with the former service and quality filters must not be restored.
const STORAGE_KEY = 'ef-recent-search-address-v1';
export const ADDRESS_SEARCH_VERSION = 'address-v1';

export function isAddressSearch(search) {
    return search?.searchVersion === ADDRESS_SEARCH_VERSION && Array.isArray(search.cards);
}

export function getRecentSearch() {
    try {
        const search = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
        if (!isAddressSearch(search)) return null;
        const cards = search.cards.map(toPublicAgencyCard).filter(Boolean);
        // Do not turn incompatible cached results into a misleading empty search.
        if (search.cards.length && !cards.length) return null;
        return { cards, searchLocation: search.searchLocation || '', searchVersion: ADDRESS_SEARCH_VERSION };
    } catch {
        return null;
    }
}

export function saveRecentSearch(search) {
    if (!isAddressSearch(search)) return;
    try {
        const cards = search.cards.map(toPublicAgencyCard).filter(Boolean);
        if (search.cards.length && !cards.length) {
            sessionStorage.removeItem(STORAGE_KEY);
            return;
        }
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
            cards,
            searchLocation: search.searchLocation || '',
            searchVersion: ADDRESS_SEARCH_VERSION,
        }));
    } catch {
        // Current navigation still works when browser storage is unavailable.
    }
}
